import { Tooltip } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import ActionIconButton from '../button/ActionIconButton';
import { ListTableActionBase } from './types';

interface ListTableActionButtonProps {
  action: ListTableActionBase;
  disabled?: boolean;
  onClick: () => void;
}

const ListTableActionButton = ({ action, disabled, onClick }: ListTableActionButtonProps) => {
  const actionButton = action.icon ? (
    <ActionIconButton
      label={action.label}
      icon={action.icon}
      tooltip={action.tooltip}
      color={action.color}
      variant={action.variant}
      disabled={disabled}
      onClick={onClick}
      size="small"
    />
  ) : (
    <Button link color="primary" disabled={disabled} onClick={onClick}>
      {action.label}
    </Button>
  );

  return action.tooltip && !action.icon ? (
    <Tooltip title={action.tooltip}>
      <span>{actionButton}</span>
    </Tooltip>
  ) : (
    actionButton
  );
};

export default ListTableActionButton;
